import { v2ApiClient } from './apiClient';

export const teacherService = {
  async getTeachers({ search = '', sectionId = 'exam', page = 1, pageSize = 10 } = {}) {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (sectionId) params.append('sectionId', sectionId);
    if (page) params.append('page', page);
    if (pageSize) params.append('pageSize', pageSize);

    const response = await v2ApiClient.get(`/lms/class/student/teachers?${params.toString()}`);
    if (response && response.isSuccessful) {
      return response;
    }
    throw new Error(response?.message || 'Failed to retrieve teachers');
  },

};

export default teacherService;
